import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { queryClient } from '../../../../../../../config/queryClient'
import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { createContactPerson } from '../../../../../../../query-api/contactPerson-query'
import { useContactDetail } from '../../../contexts/contactDetailContext'

export const useCreateContactPerson = () => {
  const { t } = useTranslation()
  const { contact } = useContactDetail()

  const {
    mutate,
    isLoading: isProcessing,
    ...rest
  } = useMutation(createContactPerson, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.Contact, contact.id])
    },
    onError: () => {
      notify({
        id: NotificationKeys.CreateContactPerson,
        message: t('error_saving'),
        variant: 'error',
      })
    },
  })

  return { createContactPerson: mutate, isProcessing, ...rest }
}
